import React, { useEffect, useState } from "react";
import { Card, CardGroup, Button, Row, Col } from "react-bootstrap";
import { Carousel } from "react-bootstrap";
import "./MyProjects.css";
import { Link } from "react-router-dom";

const MyProjects = () => {
 

   return (
      <div lg={true} style={{ backgroundColor: "black" }}>
         <div
            data-aos="fade-up"
            data-aos-easing="ease-in-sine"
            data-aos-duration="1000"
            className="container py-5"
            style={{ textAlign: "center" }}
         >
            <h1 className=" text-white ">My Projects</h1>
            <div
               style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "6px",
               }}
            >
               <p className="border-style"></p>
            </div>

            <CardGroup className="shadow-lg">
               <Card
                  className="m-4 pb-4"
                  style={{ backgroundColor: "#2C272E" }}
               >
                  <Carousel fade={true} pause={true}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/PgTd7mp/1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/r2rXQKH/7.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/FxF64d0/2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/5s4vqtr/8.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/YcYf4Nq/3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/vzkZ8z9/4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/YhQ4gJz/5.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>

                  <Card.Body>
                     <Card.Title
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        {" "}
                        NewBright Ecommerce
                     </Card.Title>
                     <Card.Text
                        className=""
                        style={{
                           textAlign: "left",
                           color: "#C0C0C0",
                           fontSize: "15px",
                        }}
                     >
                        A full-stack e-commerce website that allows users to
                        view and purchase products. Login/Sign up system based
                        on firebase and private routes. Dashboard for users,
                        editors and admins, where admins can do CRUD operations
                        and users may provide feedback and track the status of
                        their orders as well as editors can add, update and read
                        products from dashboard.
                        <div className="py-3">
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Bootstrap
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Firebase
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Router
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Node.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Express.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              MongoDB
                           </span>
                        </div>
                        <br />
                        <br />
                        <br />
                        <a
                           href="https://dashboard-ecommerce-f7a70.web.app/"
                           target="_blank"
                           className="me-2"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/dashboard-ecommerce"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </Card.Text>
                  </Card.Body>
               </Card>
               <Card
                  className="m-4 pb-4"
                  style={{ backgroundColor: "#2C272E" }}
               >
                  <Carousel fade={true} pause={true}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/cQvCnpY/Screenshot-1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/d62xJ61/Screenshot-2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/MVM3TN8/Screenshot-3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/VDmrSDj/Screenshot-4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>

                  <Card.Body>
                     <Card.Title
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        {" "}
                        Elegant Automobile
                     </Card.Title>
                     <Card.Text
                        className=""
                        style={{
                           textAlign: "left",
                           color: "#C0C0C0",
                           fontSize: "15px",
                        }}
                     >
                        A full-stack single-page automobile sales website that
                        allows visitors to see and purchase vehicles. Login
                        system based on firebase and private routes. Dashboard
                        for users and administrators, where admins can create, read, update and delete operations, and users may offer input and follow the
                        progress of their orders.
                        <div className="py-3">
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Material UI
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Firebase
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Router
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Node.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Express.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              MongoDB
                           </span>
                        </div>
                        <br />
                        <br />
                        <br />
                        <a
                           href="https://elegent-automobile.web.app/"
                           target="_blank"
                           className="me-2"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/Elegent-Automobile-Front-End"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </Card.Text>
                  </Card.Body>
               </Card>

               <Card
                  className="m-4 pb-4"
                  style={{ backgroundColor: "#2C272E" }}
                  sm={12}
                  md={6}
                  lg={4}
               >
                  <Carousel fade={true} pause={false} interval={2000}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/1m0fPgv/Screenshot-1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/0QFt44t/Screenshot-2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/j8PLX4j/Screenshot-3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/sm8QTn3/Screenshot-4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>

                  <Card.Body>
                     <Card.Title
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        {" "}
                        Travelious
                     </Card.Title>
                     <Card.Text
                        className=""
                        style={{
                           textAlign: "left",
                           color: "#C0C0C0",
                           fontSize: "15px",
                        }}
                     >
                        A full-stack single-page travel service website. Login
                        system with firebase and private routes. Clients can
                        book services and see their booked records on the
                        booking page. Clients can add services and can cancel or
                        change the status of the booking list using CRUD
                        operations.
                        <div className="py-3">
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Firebase
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React-Bootstrap
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Router
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Node.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Express.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              MongoDB
                           </span>
                        </div>
                        <br />
                        <br />
                        <br />
                        <a
                           href="https://travelious-react.web.app/"
                           target="_blank"
                           className="me-2"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/Travelious-Front-End"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </Card.Text>
                  </Card.Body>
               </Card>
               {/* <Card
                        className="m-4 pb-4"
                        style={{ backgroundColor: "#2C272E" }}
                        sm={12}
                        md={12}
                        lg={4}
                     >
                        <Carousel fade={true} pause={true}>
                           <Carousel.Item>
                              <img
                                 className="d-block w-100"
                                 src="https://i.ibb.co/71TrqgG/Screenshot-1.png"
                                 alt="First slide"
                              />
                           </Carousel.Item>
                           <Carousel.Item>
                              <img
                                 className="d-block w-100"
                                 src="https://i.ibb.co/nDScTPB/Screenshot-2.png"
                                 alt="First slide"
                              />
                           </Carousel.Item>
                           <Carousel.Item>
                              <img
                                 className="d-block w-100"
                                 src="https://i.ibb.co/GCCh4CN/Screenshot-3.png"
                                 alt="First slide"
                              />
                           </Carousel.Item>
                           <Carousel.Item>
                              <img
                                 className="d-block w-100"
                                 src="https://i.ibb.co/dB45zWr/Screenshot-4.png"
                                 alt="First slide"
                              />
                           </Carousel.Item>
                        </Carousel>

                        <Card.Body>
                           <Card.Title
                              style={{ textAlign: "justify", color: "#C0C0C0" }}
                           >
                              {" "}
                              Elderly Care
                           </Card.Title>
                           <Card.Text
                              className=""
                              style={{
                                 textAlign: "left",
                                 color: "#C0C0C0",
                                 fontSize: "15px",
                              }}
                           >
                              Eldery Care is a front-end Health Care Service
                              Provider web app. Login system based on firebase
                              and private routes. Login and registration system
                              with firebase authentication and private routes.
                              Clients can the single service information.
                              <div>
                                 <span
                                    className="me-2 text-nowrap d-inline-block"
                                    style={{
                                       border: "1px solid",
                                       padding: "5px",
                                       borderRadius: "5px",
                                    }}
                                 >
                                    React.js
                                 </span>
                                 <span
                                    className="me-2 text-nowrap d-inline-block"
                                    style={{
                                       border: "1px solid",
                                       padding: "5px",
                                       borderRadius: "5px",
                                    }}
                                 >
                                    React-Bootstrap
                                 </span>
                                 <span
                                    className="me-2 text-nowrap d-inline-block mt-2"
                                    style={{
                                       border: "1px solid",
                                       padding: "5px",
                                       borderRadius: "5px",
                                    }}
                                 >
                                    React Router
                                 </span>
                                 <span
                                    className="me-2 text-nowrap d-inline-block mt-2"
                                    style={{
                                       border: "1px solid",
                                       padding: "5px",
                                       borderRadius: "5px",
                                    }}
                                 >
                                    React Hook
                                 </span>
                                 <span
                                    className="me-2 text-nowrap d-inline-block mt-2"
                                    style={{
                                       border: "1px solid",
                                       padding: "5px",
                                       borderRadius: "5px",
                                    }}
                                 >
                                    Firebase
                                 </span>
                              </div>
                              <br />
                              <br />
                              <br />
                              <a
                                 href="https://eldery-care.web.app/"
                                 target="_blank"
                                 className="me-2"
                              >
                                 <Button className="btn-sm">
                                    {" "}
                                    <i class="fas fa-external-link-alt"></i>{" "}
                                    Live Link
                                 </Button>
                              </a>{" "}
                              <a
                                 href="https://github.com/bakhtiarabid/eldery-care-react"
                                 target="_blank"
                              >
                                 <Button className="btn-sm">
                                    {" "}
                                    <i class="fab fa-github"></i> GitHub
                                 </Button>
                              </a>
                           </Card.Text>
                        </Card.Body>
                     </Card> */}
            </CardGroup>
            <div className="py-5">
               <Link to="/projects">
                  <Button>See More</Button>
               </Link>
            </div>
         </div>
      </div>
   );
};

export default MyProjects;
